# external packages
window.Backbone ?= require 'backbone'
window.Backbone.$ ?= window.$

####################################################
# packages that need to be updated to ITA 3        #
# it still works in this way but that's just dirty #
####################################################
# Booking module templates
BookingTemplates = window.BookingTemplates ?= {}
_.extend BookingTemplates,
  "booking_frontend_templates_book": require '../../modules/booking/frontend/templates/book.html.mustache'
  "booking_frontend_templates_calendar": require '../../modules/booking/frontend/templates/calendar.html.mustache'
  "booking_frontend_templates_datetimepicker": require '../../modules/booking/frontend/templates/datetimepicker.html.mustache'
  "booking_frontend_templates_datepicker": require '../../modules/booking/frontend/templates/datepicker.html.mustache'
  "booking_frontend_templates_deal_booker": require '../../modules/booking/frontend/templates/deal/booker.html.mustache'
  "booking_frontend_templates_info": require '../../modules/booking/frontend/templates/info.html.mustache'
  "booking_frontend_templates_option": require '../../modules/booking/frontend/templates/option.html.mustache'
  "booking_frontend_templates_optionpicker": require '../../modules/booking/frontend/templates/optionpicker.html.mustache'
  "booking_frontend_templates_partysize": require '../../modules/booking/frontend/templates/partysize.html.mustache'
  "booking_frontend_templates_partysizepicker": require '../../modules/booking/frontend/templates/partysizepicker.html.mustache'
  "booking_frontend_templates_partysizes": require '../../modules/booking/frontend/templates/partysizes.html.mustache'
  "booking_frontend_templates_picker_notice": require '../../modules/booking/frontend/templates/picker_notice.html.mustache'
  "booking_frontend_templates_phone": require '../../modules/booking/frontend/templates/phone.html.mustache'
  "booking_frontend_templates_question": require '../../modules/booking/frontend/templates/question.html.mustache'
  "booking_frontend_templates_time": require '../../modules/booking/frontend/templates/time.html.mustache'
  "booking_frontend_templates_timebubble": require '../../modules/booking/frontend/templates/timebubble.html.mustache'
  "booking_frontend_templates_timebubbles": require '../../modules/booking/frontend/templates/timebubbles.html.mustache'
  "booking_frontend_templates_timepicker": require '../../modules/booking/frontend/templates/timepicker.html.mustache'
  "booking_frontend_templates_times": require '../../modules/booking/frontend/templates/times.html.mustache'
  "booking_frontend_templates_tooltip": require '../../modules/booking/frontend/templates/tooltip.html.mustache'
  "booking_frontend_templates_text_notifications": require '../../modules/booking/frontend/templates/text_notifications.html.mustache'
  "glive-booking_frontend_templates_deal_booker": require '../../modules/glive-booking/frontend/templates/deal/booker.html.mustache'
  "glive-booking_frontend_templates_gliveinfo": require '../../modules/glive-booking/frontend/templates/gliveinfo.html.mustache'
  "glive-booking_frontend_templates_book": require '../../modules/glive-booking/frontend/templates/book.html.mustache'
  "glive-booking_frontend_templates_calendar": require '../../modules/glive-booking/frontend/templates/calendar.html.mustache'
  "glive-booking_frontend_templates_datepicker": require '../../modules/glive-booking/frontend/templates/datepicker.html.mustache'
  "glive-booking_frontend_templates_time": require '../../modules/glive-booking/frontend/templates/time.html.mustache'
  "glive-booking_frontend_templates_timepicker": require '../../modules/glive-booking/frontend/templates/timepicker.html.mustache'
  "glive-booking_frontend_templates_times": require '../../modules/glive-booking/frontend/templates/times.html.mustache'
  "glive-booking_frontend_templates_quantity": require '../../modules/glive-booking/frontend/templates/quantity.html.mustache'
  "glive-booking_frontend_templates_quantities": require '../../modules/glive-booking/frontend/templates/quantities.html.mustache'
  "glive-booking_frontend_templates_quantitypicker": require '../../modules/glive-booking/frontend/templates/quantitypicker.html.mustache'
  "glive-booking_frontend_templates_section": require '../../modules/glive-booking/frontend/templates/section.html.mustache'
  "glive-booking_frontend_templates_sectionpicker": require '../../modules/glive-booking/frontend/templates/sectionpicker.html.mustache'
  "glive-booking_frontend_templates_price": require '../../modules/glive-booking/frontend/templates/price.html.mustache'
  "glive-booking_frontend_templates_pricepicker": require '../../modules/glive-booking/frontend/templates/pricepicker.html.mustache'

# shared booking libs
window.moment = require '../../node_modules/moment/moment.js'
window.CLNDR = require '../../node_modules/booking-components/node_modules/online-booking-clndr/src/clndr.js'
window.autosize = require '../../node_modules/booking-components/modules/booking/frontend/vendor/jquery.autosize.js'
require '../../node_modules/moment-timezone/moment-timezone.js'
window.Backbone.Obscura = require '../../node_modules/glive-booking-components/node_modules/backbone.obscura/backbone.obscura.js'

# LocalBookingWrapper (ordered by dependencies, don't change the order ....)
require '../../modules/booking/frontend/base'
require '../../modules/booking/frontend/helpers'
require '../../modules/booking/frontend/models/base'
require '../../modules/booking/frontend/collections/base'
require '../../modules/booking/frontend/models/attribute'
require '../../modules/booking/frontend/collections/attributes'
require '../../modules/booking/frontend/models/local_booking_settings'
require '../../modules/booking/frontend/models/option'
require '../../modules/booking/frontend/collections/options'
require '../../modules/booking/frontend/models/time'
require '../../modules/booking/frontend/collections/availability'
require '../../modules/booking/frontend/models/partysize'
require '../../modules/booking/frontend/collections/partysizes'
require '../../modules/booking/frontend/models/possible_segment'
require '../../modules/booking/frontend/collections/possible_segments'
require '../../modules/booking/frontend/models/reservation'
require '../../modules/booking/frontend/collections/reservations'
require '../../modules/booking/frontend/models/booker'

require '../../modules/booking/frontend/presenters/base'
require '../../modules/booking/frontend/presenters/booker'
require '../../modules/booking/frontend/presenters/info'
require '../../modules/booking/frontend/presenters/picker'
require '../../modules/booking/frontend/presenters/option'
require '../../modules/booking/frontend/presenters/optionpicker'
require '../../modules/booking/frontend/presenters/calendar'
require '../../modules/booking/frontend/presenters/timebubble'
require '../../modules/booking/frontend/presenters/timebubbles'
require '../../modules/booking/frontend/presenters/datetimepicker'
require '../../modules/booking/frontend/presenters/partysize'
require '../../modules/booking/frontend/presenters/partysizepicker'
require '../../modules/booking/frontend/presenters/picker_notice'
require '../../modules/booking/frontend/presenters/question'
require '../../modules/booking/frontend/presenters/phone'
require '../../modules/booking/frontend/presenters/text_notifications'
require '../../modules/booking/frontend/presenters/book'

require '../../modules/booking/frontend/views/base'
require '../../modules/booking/frontend/views/book'
require '../../modules/booking/frontend/views/collection'
require '../../modules/booking/frontend/views/tooltip'

require '../../modules/booking/frontend/views/drawers/info'
require '../../modules/booking/frontend/views/drawers/phone'
require '../../modules/booking/frontend/views/drawers/pickers'
require '../../modules/booking/frontend/views/drawers/question'
require '../../modules/booking/frontend/views/drawers/text_notifications'

require '../../modules/booking/frontend/views/pickers/picker/picker_collection'
require '../../modules/booking/frontend/views/pickers/picker/picker_element'
require '../../modules/booking/frontend/views/pickers/picker/picker_notice'
require '../../modules/booking/frontend/views/pickers/picker/picker'

require '../../modules/booking/frontend/views/pickers/datetime/calendar'
require '../../modules/booking/frontend/views/pickers/datetime/timebubble'
require '../../modules/booking/frontend/views/pickers/datetime/timebubbles'
require '../../modules/booking/frontend/views/pickers/datetime/datetimepicker'

require '../../modules/booking/frontend/views/pickers/option/option'
require '../../modules/booking/frontend/views/pickers/option/options'
require '../../modules/booking/frontend/views/pickers/option/optionpicker'

require '../../modules/booking/frontend/views/pickers/partysize/partysize'
require '../../modules/booking/frontend/views/pickers/partysize/partysizes'
require '../../modules/booking/frontend/views/pickers/partysize/partysizepicker'

require '../../modules/booking/frontend/views/booker'

require '../../modules/booking/frontend/initializers/deal/booker'
require '../../modules/deal/frontend/local_booking_wrapper'

# GliveBookingWrapper (ordered by dependencies, don't change the order ....)
require '../../modules/glive-booking/bc_bundle'
require '../../modules/glive-booking/frontend/base'
require '../../modules/glive-booking/frontend/models/time'
require '../../modules/glive-booking/frontend/collections/times'
require '../../modules/glive-booking/frontend/models/section'
require '../../modules/glive-booking/frontend/collections/sections'
require '../../modules/glive-booking/frontend/models/price'
require '../../modules/glive-booking/frontend/collections/prices'
require '../../modules/glive-booking/frontend/models/event'
require '../../modules/glive-booking/frontend/collections/events'

require '../../modules/glive-booking/frontend/filtered_collections/base'
require '../../modules/glive-booking/frontend/filtered_collections/events'

require '../../modules/glive-booking/frontend/models/booker'
require '../../modules/glive-booking/frontend/presenters/booker'
require '../../modules/glive-booking/frontend/presenters/info'
require '../../modules/glive-booking/frontend/views/info'
require '../../modules/glive-booking/frontend/views/picker'
require '../../modules/glive-booking/frontend/presenters/datepicker'
require '../../modules/glive-booking/frontend/presenters/calendar'
require '../../modules/glive-booking/frontend/views/calendar'
require '../../modules/glive-booking/frontend/views/datepicker'
require '../../modules/glive-booking/frontend/presenters/time'
require '../../modules/glive-booking/frontend/presenters/timepicker'
require '../../modules/glive-booking/frontend/views/time'
require '../../modules/glive-booking/frontend/views/times'
require '../../modules/glive-booking/frontend/views/timepicker'
require '../../modules/glive-booking/frontend/presenters/quantitypicker'
require '../../modules/glive-booking/frontend/presenters/quantity'
require '../../modules/glive-booking/frontend/views/quantity'
require '../../modules/glive-booking/frontend/views/quantities'
require '../../modules/glive-booking/frontend/views/quantitypicker'
require '../../modules/glive-booking/frontend/presenters/sectionpicker'
require '../../modules/glive-booking/frontend/presenters/section'
require '../../modules/glive-booking/frontend/views/section'
require '../../modules/glive-booking/frontend/views/sections'
require '../../modules/glive-booking/frontend/views/sectionpicker'
require '../../modules/glive-booking/frontend/presenters/pricepicker'
require '../../modules/glive-booking/frontend/presenters/price'
require '../../modules/glive-booking/frontend/views/price'
require '../../modules/glive-booking/frontend/views/prices'
require '../../modules/glive-booking/frontend/views/pricepicker'
require '../../modules/glive-booking/frontend/presenters/book'
require '../../modules/glive-booking/frontend/views/book'
require '../../modules/glive-booking/frontend/views/booker'

require '../../modules/glive-booking/frontend/initializers/deal/glive-booker'
